import { render } from "./RoutingForm.vue?vue&type=template&id=65b725b0&scoped=true"
import script from "./RoutingForm.vue?vue&type=script&lang=js"
export * from "./RoutingForm.vue?vue&type=script&lang=js"

import "./RoutingForm.vue?vue&type=style&index=0&id=65b725b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b725b0"]])

export default __exports__